import * as Yup from 'yup';
import { AuditingEntity, Insuree } from '@models';

export function useValidationSchema() {
  return Yup.object<Insuree>().shape({
    insuredSubject: Yup.mixed<AuditingEntity>().nullable().required(),
  }) as Yup.Schema<Insuree>;
}
